import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
export default BaseChannelSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    integration: {
      embedded: 'always'
    },
    accountIssues: {
      embedded: 'always'
    },
    channelMetas: {
      embedded: 'always'
    }
  },
  modelNameFromPayloadKey() {
    return 'channels/channel';
  }
});